import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const totalHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "toptotal",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
